
/**
 * PushState
 *
 * @export
 * @class PushState
 */
export default class PushState{

    /**
     * Push in history
     *
     * @static
     * @param {any} options
     * @memberof PushState
     */
    static push(...options){
        const [Title, Url] = options;
        const pushObj = {
            Title,
            Url
        };
        window.history.pushState(pushObj, pushObj.Title, pushObj.Url);
    }
}


// WEBPACK FOOTER //
// /src/common/pushState.js